import API from 'src/api'
import { http } from '../boot/axios'

export default {
  URL: API.GRAPHQL_URL + 'recurrences',
  fetch (recurrenceId) {
    return new Promise((resolve, reject) => {
      http.get(`${this.URL}/${recurrenceId}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getRecurrence (recurrenceId) {
    return new Promise((resolve, reject) => {
      http.get(`${this.URL}/recurrence/${recurrenceId}`)
        .then(response => resolve(response.data.data))
        .catch(err => reject(err))
    })
  }
}
